const colors = {
  accent: 'rgb(255, 20, 87)',
  accent_alpha: 'rgba(255, 20, 87, 0.1)',
  pristine: 'rgb(255, 255, 255)',
  pristine_alpha: 'rgba(255, 255, 255, .5)',
  transparent: 'transparent',
  ultrablack: 'rgb(43, 44, 48)',
  black: 'rgb(53, 49, 59)',
  ultrapurple: 'rgb(69, 55, 69)',
  purple: 'rgb(97, 60, 76)',
  highlight: '#ff5555',
};
export { colors };
